// LocalStorageService.js
const LocalStorageService = (function () {
  var _service;
  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }
    return _service;
  }
  function _setData(key, value) {
    localStorage.setItem(key, value);
  }
  function _getData(key) {
    const local = localStorage.getItem(key);
    return local !== null ? JSON.parse(local) : [];
  }
  function _clearData(key) {
    localStorage.removeItem(key);
  }
  function _setState(key, value) {
    localStorage.setItem(key, value);
  }
  function _getState(key) {
    const local = localStorage.getItem(key);
    return local !== null ? local : false;
  }
  function _clearState(key) {
    localStorage.removeItem(key);
  }
  function _setToken(value) {
    localStorage.setItem('access_token', value.token);
    localStorage.setItem('refresh_token', value.token);
  }
  function _getAccessToken() {
    return localStorage.getItem('access_token');
  }
  function _getRefreshToken() {
    return localStorage.getItem('refresh_token');
  }
  function _clearToken() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  }
  return {
    getService: _getService,
    setToken: _setToken,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    clearToken: _clearToken,
    setData: _setData,
    getData: _getData,
    clearData: _clearData,
    setState: _setState,
    getState: _getState,
    clearState: _clearState,
  };
})();

export default LocalStorageService;
